class SinaCovaCatalog {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.container = document.getElementById('shopify-section-' + sectionId);
    
    if (!this.container) return;

    this.init();
  }

  init() {
    this.initObserver();
    this.initParallax();
    this.initSlider();
  }

  initObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.1 });

    this.container.querySelectorAll('.reveal-on-scroll').forEach(el => observer.observe(el));
  }

  initParallax() {
    const parallaxElements = this.container.querySelectorAll('.parallax-element');
    if (parallaxElements.length === 0) return;

    const updateParallax = () => {
      const currentScrollY = window.scrollY;
      parallaxElements.forEach(el => {
        const rect = el.getBoundingClientRect();
        // 画面内にある、または画面に近い場合のみ計算
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            const datasetSpeed = parseFloat(el.getAttribute('data-speed'));
            const speed = isNaN(datasetSpeed) ? 0.05 : datasetSpeed;
            // 要素の初期位置基準ではなくコンテナ基準などで計算することもあるが、
            // ここでは元のロジックなどを尊重しつつ最適化
            const offset = (currentScrollY - (el.offsetTop - window.innerHeight * 0.5)) * speed;
            el.style.transform = `translateY(${offset}px)`;
        }
      });
      requestAnimationFrame(updateParallax);
    };

    updateParallax();
  }

  initSlider() {
    const sliderContainer = document.getElementById('slider-container-' + this.sectionId);
    if (!sliderContainer) return;

    let targetScroll = 0;
    let currentScroll = 0;
    let isAnimating = false;

    // 初期化
    targetScroll = sliderContainer.scrollLeft;
    currentScroll = sliderContainer.scrollLeft;

    const lerp = (s, e, f) => s + (e - s) * f;

    const updateScroll = () => {
      currentScroll = lerp(currentScroll, targetScroll, 0.08);
      sliderContainer.scrollLeft = currentScroll;
      
      if (Math.abs(targetScroll - currentScroll) > 0.5) {
        requestAnimationFrame(updateScroll);
        isAnimating = true;
      } else {
        isAnimating = false;
      }
    };

    sliderContainer.addEventListener('wheel', (e) => {
      // 縦スクロールを横スクロールに変換したい場合のみ preventDefault するが
      // ここでは元のロジックに従い、横スクロール目的のホイール操作とみなして処理する
      if (e.deltaY !== 0) {
        e.preventDefault();
        
        if (!isAnimating) {
          currentScroll = sliderContainer.scrollLeft;
          // 急激な変化を防ぐためのリセットロジック
          if (Math.abs(currentScroll - targetScroll) > 100) targetScroll = currentScroll;
        }

        targetScroll += e.deltaY * 2.5;
        targetScroll = Math.max(0, Math.min(targetScroll, sliderContainer.scrollWidth - sliderContainer.clientWidth));
        
        if (!isAnimating) requestAnimationFrame(updateScroll);
      }
    }, { passive: false });
  }
}

// グローバルスコープにクラスを公開（必要に応じて）
window.SinaCovaCatalog = SinaCovaCatalog;
